import React from 'react';
import { Container } from '@pixi/react';
import JackpotLogo from './logo';
import JackpotStage from './stage';
import JackpotProjector from './projector';
import JackpotStars from './stars';
import ScaleComponent from '../../../mobile/scaleComponent';

function JackpotBackGround() {
  return (
    <Container name='JackpotBackGround'>
      <ScaleComponent positionX={window.innerWidth / 2} isTop>
        <JackpotLogo />
      </ScaleComponent>
      <ScaleComponent positionX={window.innerWidth / 2} isBottom>
        <JackpotStage />
      </ScaleComponent>
      <JackpotStars />
      <JackpotProjector />
    </Container>
  );
}
export default JackpotBackGround;
